export const CHECKOUT_URL =
  'https://mega-pack-metodologia-de-la-investigacion-360.impultienda.ar/checkout'

export const OFFER = {
  name: 'Mega Pack Metodología de la Investigación 360',
  price: 19.9,
  currency: 'USD',
}
